export default __webpack_public_path__ + "static/media/ic_costa_rica.370902cd.svg";